// This legacy app is deprecated; users are sent here instead.
const NEW_DASHBOARD_URL = 'https://dashboard.nexlev.io';

export default NEW_DASHBOARD_URL;
